@import '../../styles/host.css';

:host {
    display: block;
}

.tab-list {
    display: flex;
    align-items: center;
    overflow-x: auto;
    margin: 0;
    padding: 0;
    border-top: 1px solid var(--protean-tab-container-separator-color, #535353);
    list-style: none;
}

.tab-list button {
    font-size: 1.125rem;
    padding: 1rem;
    text-decoration: none;
    color: inherit;
    transition:
        color 0.2s ease-in-out,
        background-color 0.2s ease-in-out,
        box-shadow 0.2s ease-in-out;
}

.tab-list button:hover {
    background-color: var(
        --protean-tab-container-hover-background-color,
        #353535
    );
    color: var(--protean-tab-container-hover-text-color, inherit);
}

.tab-list button[aria-selected='true'] {
    box-shadow: inset var(--protean-tab-container-active-border-color, #c7b5fb)
        0 5px;
}
